import { useState, useEffect, useCallback } from 'react';
import { createGlobalState } from 'react-use';
import useRecord from './useRecord';

const initialState = {
	basicInfo: {},
	exhibitorInfo: [],
	productInfo: [],
	floorInfo: [],
};

const useDataState = createGlobalState(initialState);

const useData = () => {
	const [dataState, setDataState] = useDataState();
	const [dataFetched, setDataFetched] = useState(false);
	const { makeRecord } = useRecord();

	useEffect(() => {
		if (!dataFetched) {
			fetch('./data.json')
				.then(response => response.json())
				.then(data => {
					const localData = JSON.parse(localStorage.getItem('data'));

					const processedData = {
						...data,
						exhibitorInfo: data.exhibitorInfo.map(exhibitor => {
							const products = data.productInfo.filter(product => product['攤位號碼'] === exhibitor['攤位號碼']);

							let favourite = false;

							if (localData && localData.favouriteExhibitors) {
								favourite = localData.favouriteExhibitors.includes(exhibitor['攤位號碼']);
							}

							return {
								...exhibitor,
								products,
								favourite,
							};
						}),
					};

					setDataFetched(true);
					setDataState(processedData);
				})
				.catch(error => console.error(error));
		}
	}, [dataFetched, setDataState]);

	const toggleFavourite = useCallback((boothNumber) => {
		const updatedExhibitorInfo = dataState.exhibitorInfo.map(exhibitor => {
			if (exhibitor['攤位號碼'] === boothNumber) {
				const updatedExhibitor = {
					...exhibitor,
					favourite: !exhibitor.favourite,
				};

				const localData = JSON.parse(localStorage.getItem('data'));

				if (localData) {
					if (updatedExhibitor.favourite) {
						localData.favouriteExhibitors.push(boothNumber);
					} else {
						localData.favouriteExhibitors = localData.favouriteExhibitors.filter(favouriteBoothNumber => favouriteBoothNumber !== boothNumber);
					}
					localStorage.setItem('data', JSON.stringify(localData));
				} else {
					localStorage.setItem('data', JSON.stringify({
						favouriteExhibitors: [boothNumber],
					}));
				}

				if (updatedExhibitor.favourite) makeRecord({ Action: 'F', Booth: boothNumber });

				return updatedExhibitor;
			}

			return exhibitor;
		});

		setDataState({
			...dataState,
			exhibitorInfo: updatedExhibitorInfo,
		});
	}, [dataState, makeRecord, setDataState]);

	return {
		basicInfo: dataState.basicInfo,
		exhibitorInfo: dataState.exhibitorInfo,
		productInfo: dataState.productInfo,
		floorInfo: dataState.floorInfo,
		dataFetched,
		toggleFavourite,
		setDataFetched,
	};
}
export default useData;